import { render, staticRenderFns } from "./WPriceV2.vue?vue&type=template&id=6d4a43eb&"
import script from "./WPriceV2.vue?vue&type=script&lang=js&"
export * from "./WPriceV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports